/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuthenticationRequestDTO,
    AuthenticationRequestDTOFromJSON,
    AuthenticationRequestDTOFromJSONTyped,
    AuthenticationRequestDTOToJSON,
} from './AuthenticationRequestDTO';

/**
 * 
 * @export
 * @interface RequestDTO
 */
export interface RequestDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestDTO
     */
    endpoint?: string;
    /**
     * 
     * @type {AuthenticationRequestDTO}
     * @memberof RequestDTO
     */
    authenticationRequest?: AuthenticationRequestDTO;
}

export function RequestDTOFromJSON(json: any): RequestDTO {
    return RequestDTOFromJSONTyped(json, false);
}

export function RequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'authenticationRequest': !exists(json, 'authenticationRequest') ? undefined : AuthenticationRequestDTOFromJSON(json['authenticationRequest']),
    };
}

export function RequestDTOToJSON(value?: RequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'endpoint': value.endpoint,
        'authenticationRequest': AuthenticationRequestDTOToJSON(value.authenticationRequest),
    };
}

